import App from './src/App'

const name = 'Live Receptionist'

/**
 *
 */
export { name }
export default App
